import Echo from 'laravel-echo';
import Vue from 'vue';

window.Pusher = require('pusher-js');

let echoConfig = {
  cluster: process.env.VUE_APP_PUSHER_CLUSTER,
  broadcaster: 'pusher',
  key: process.env.VUE_APP_PUSHER_APP_KEY,
  wsHost: window.location.hostname,
  wsPort: process.env.VUE_APP_PUSHER_APP_WS_PORT_NUMBER,
  wssPort: process.env.VUE_APP_PUSHER_APP_WSS_PORT_NUMBER,
  disableStats: true,
  forceTLS: false,
  enabledTransports: ['ws'],
  encrypted: false,
};

Vue.prototype.$echo = new Echo(echoConfig);
